// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[dir=\"rtl\"] .TVGk7on48bS3upNRThmoiw\\=\\={transform:scaleX(-1)}", "",{"version":3,"sources":["webpack://./../esm-styleguide/src/icons/icons.module.scss"],"names":[],"mappings":"AACE,wCACE,oBAAA","sourcesContent":[":global([dir='rtl']) {\n  .icon {\n    transform: scaleX(-1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "TVGk7on48bS3upNRThmoiw=="
};
export default ___CSS_LOADER_EXPORT___;
